module.exports = __webpack_public_path__ + "88e725331e73541937a651afdd6cfb2f.pdf";